<div class="container">
    <tam-splitter splitterBarWidth=3 [direction]="'horizontal'" [useTransition]="300">
        <tam-splitter-panel [size]="entityListWidth" [max]="50" [min]="20">
            <div class="list-container" loading-spin [isLoading]="!inited" [loadingSize]="'big'">
                <div class="tool-bar" [ngClass]="{'hide': !config||config.hideKeyword}" *ngIf="!isShowBulkAction">
                    <div tid="keyword-search" class="search-box">
                        <keyword-search [config]="keywordSearchConfig"></keyword-search>
                    </div>
                    <div class="right-menu">
                        <smart-icon name="refresh" class="light" (click)="clickRefreshEntitytList()"></smart-icon>
                        <smart-icon name="meatball" class="light meatball" (click)="showContextMenu($event)"
                            *ngIf="isAdminUser && isComplianceUser"></smart-icon>
                    </div>
                </div>
                <div class="bulk-action" *ngIf="isShowBulkAction">
                    <span class="h3-regular">{{'crm.entity_bulk_actions' |stringLiterals}}</span>
                    <button tam-button tamType="tertiary" tamSize="normal" (click)="onExitClick()">
                        {{'crm.exit' |stringLiterals}}
                    </button>

                </div>
                <tam-context-menu [config]="operationContextMenuConfig"></tam-context-menu>
                <div class="grid" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
                    <ag-grid-angular style="width: 100%; height: 100%;-webkit-touch-callout: default;"
                        class="ag-theme-balham" [columnDefs]="columnDefs" [gridOptions]="gridOptions"
                        (gridReady)="onGridReady($event)" (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
                        (bodyScroll)="onBodyScroll($event)" (selectionChanged)="onRowSelected($event)"
                        (keydown)="onKeydown($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </tam-splitter-panel>
        <tam-splitter-panel [size]="50" [max]="80" [min]="50">
            <div *ngIf="entityId!==null || !isShowBulkAction" class="detail-container">
                <entity-panel [config]='entityConfig'></entity-panel>
            </div>
            <div *ngIf="!entityId">
                <div class="no-data">
                    <span>Select an item to view</span>
                </div>
            </div>
        </tam-splitter-panel>
    </tam-splitter>
</div>